/* eslint-disable */
import TermPage from '../../../components/pages/termPage'

const Privacy = ({ className }) => {
   return (
      <TermPage className={className} currentKey="privacy" />
   )
}
export default Privacy